import React from 'react';
import PropTypes from 'prop-types';

import * as styles from '@Theme/hellofinance/modules/TableOfContents/TableOfContents.module.scss';

const propTypes = {
  /**
   * Node element
   */
  node: PropTypes.object
};

const handleScroll = node => {
  const scrollTop = node.getBoundingClientRect().top + window.scrollY - 24;

  window.scrollTo({
    top: scrollTop > window.scrollY ? scrollTop : scrollTop - document.querySelector('header').offsetHeight, // hack
    behavior: 'smooth'
  });
};

const TableOfContentsItem = ({
  node
}) => {
  if (!node) {
    return false;
  }

  return <li onClick={() => handleScroll(node)} className={styles.rootListItem}>
    <span className={styles.rootListLink}>{node.textContent}</span>
  </li>;
};

TableOfContentsItem.propTypes = propTypes;

export default TableOfContentsItem;
